import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ForumHeader from './ForumHeader'
import Container from '@material-ui/core/Container'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { useParams } from 'react-router-dom'
import { forumQueries } from '../../graphql/queries'
import { forumMutations } from '../../graphql/mutations'
import TopicCard from '../../components/Forum/TopicCard'
import TopicCardResponse from '../../components/Forum/TopicCardResponse'
import * as loggerClient from '../../services/loggerClient'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    overflowY: 'scroll'
  },
  wrapperTopic: {
    marginTop: 48
  },
  formControl: {
    width: '30%',
    marginRight: 36,
    marginBottom: 0,
    '& fieldset': {
      border: 'none'
    },
    '& div': {
      background: '#fff',
      padding: 8
    }
  },
  filters: {
    flex: 1
  },
  newButton: {
    width: 'auto'
  }
}))

const Profile = ({ _id, query }) => {
  const classes = useStyles()
  const { topicoId, cursoId } = useParams()
  const { loading: loadingTopic, data: dataTopic } = useQuery(forumQueries.GET_FORUM_TOPIC, {
    variables: { topico_id: topicoId }
  })
  const [adicionaVisualizacaoTopico] = useMutation(forumMutations.ADD_TOPIC_VISUALIZATION)

  useEffect(() => {
    if (topicoId) {
      loggerClient.onShowTestResult({
        origem: cursoId, 
        topico: topicoId,
        contexto: 'forum',
        evento: 'visualizacao'
      })
    }

    adicionaVisualizacaoTopico({ variables: { _id: topicoId } })
  }, [topicoId]) // eslint-disable-line

  const topicoForum = (dataTopic || {}).topicoForum || {}

  return (
    <div className={classes.root}>
      <Container>
        <ForumHeader title={loadingTopic ? 'Carregando...' : `${topicoForum.titulo || 'Tópico não encontrado'}`} />
      </Container>
      <Container className={classes.wrapperTopic}>
        <TopicCard
          _id={topicoForum._id}
          detail={true}
          topico_id={topicoForum._id}
          curso_id={cursoId}
          category={(topicoForum.categoria || {}).label}
          description={topicoForum.descricao}
          title={topicoForum.titulo}
          loading={loadingTopic}
          visualizacoes={(topicoForum || {}).visualizacoes || 0}
          createdAt={topicoForum.createdAt}
          postadoPor={topicoForum.postadoPor}
          query={{ query: forumQueries.GET_FORUM_TOPIC, variables: { topico_id: topicoId } }}
        />
        {(topicoForum.respostas || []).map(response => (
          <TopicCardResponse
            _id={response._id}
            topico_id={topicoId}
            curso_id={cursoId}
            description={response.descricao}
            createdAt={response.createdAt}
            postadoPor={response.postadoPor}
            respostas={response.respostas}
            query={{ query: forumQueries.GET_FORUM_TOPIC, variables: { topico_id: topicoId } }}
          />
        ))}
      </Container>
    </div>
  )
}

export default Profile
